module.exports = __webpack_public_path__ + "static/media/s_v5_t2.8a709135.mp3";